// Split a base64 PDF into smaller page-range chunks, in the browser.
// Large multi-month statements are processed chunk-by-chunk so each extraction call has
// a bounded output (no truncation) and a smaller input (won't trip rate limits).
import { PDFDocument } from 'pdf-lib';

function base64ToBytes(b64) {
  const bin = atob(b64);
  const len = bin.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i++) bytes[i] = bin.charCodeAt(i);
  return bytes;
}

// Returns { total, chunks: [{ base64, from, to, pages }] }. If the PDF has
// pagesPerChunk or fewer pages, a single chunk (the whole document) is returned.
export async function splitPdfBase64(b64, pagesPerChunk) {
  const per = Math.max(1, pagesPerChunk || 3);
  const src = await PDFDocument.load(base64ToBytes(b64));
  const total = src.getPageCount();
  const chunks = [];
  for (let start = 0; start < total; start += per) {
    const end = Math.min(start + per, total);
    const out = await PDFDocument.create();
    const idxs = [];
    for (let i = start; i < end; i++) idxs.push(i);
    const copied = await out.copyPages(src, idxs);
    copied.forEach((p) => out.addPage(p));
    const chunkB64 = await out.saveAsBase64();
    chunks.push({ base64: chunkB64, from: start + 1, to: end, pages: idxs.length });
  }
  return { total, chunks };
}
